module.exports = __webpack_public_path__ + "static/media/Maven_3030.42e6b4a6.jpg";